import {contextify} from 'common/util/react';
import {DashboardSelectorController} from 'common/report/controllers/dashboard-selector-controller';

const context = contextify<DashboardSelectorController>();

export const DashboardSelectorControllerProvider = context.Provider;
export const DashboardSelectorControllerConsumer = context.Consumer;
export const useDashboardSelectorController = context.hook;
